import MaxDraftInput from './MaxDraftInput'

export default MaxDraftInput
